const isFourHundredError = (errorCode: number): boolean => {
  const fourHundredErrors = [400, 401, 404, 403, 405, 415]
  return fourHundredErrors.indexOf(errorCode) >= 0
}

export default isFourHundredError
